<template>
  <N2PaginaGaleria v-if="disenoPropio" />
  <div v-else>

    <SliderBannerNotinTwo :obj="store.NOTARIA.Theme.Gallery" type="gallery" />

    <!-- Start team Area  -->
    <GalleryList/>

  </div>
</template>

<script setup lang="ts">
// Plantillas 2 a 5: la página con el diseño de su portada (refs: https://trello.com/c/3g3PTnq5, https://trello.com/c/MGgrmuPY, https://trello.com/c/XU15s9gl, https://trello.com/c/0Ma2vfxV)
import N2PaginaGaleria from '../components/notaria2/N2PaginaGaleria.vue'
import { useDisenoPropio } from '../composables/useNotaria2'
const disenoPropio = useDisenoPropio()
import { useStore } from '../store/index'
const store = useStore()
const PageName ="Gallery"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
const breadcrumbs= [
  {
    text: "Home",
    to: "/",
    disabled: false,
  },
  {
    text: "Gallery",
    to: "",
    disabled: true,
  },
]
</script>
